/* ============================================================================
   HOSTED FLOW BETA — status job customer (Control Panel, bawah pemilih mode)
   ============================================================================
   Selepas Submit, setiap card+set yang dihantar ke PC ofis tunjuk status di sini,
   dan KEKAL bila customer buka semula browser (dibaca dari queue server /status):
     Dalam barisan → Sedang dijana → Menyimpan → Siap · atau Perlu semakan.
   · 'Siap'/'Dibatalkan' disembunyikan (video dah ada pada card / tiada kerja).
   · 'Dalam barisan' (belum dihantar ke Google) → butang Batal (server pulang kuota).
   i18n: kunci hosted.* (ms.js + en.js). Guna statusPelanggan yang server kira (sepadan dashboard admin).
   ========================================================================== */
import { useEffect, useState, useCallback } from 'react';
import { useT } from '../i18n';
import { bacaStatusHostedBeta, batalFlowJob } from '../services/centralWorkerService';

const TONE = {
  dalam_barisan: { bg: 'var(--s-ink-7, #eef0f4)', fg: 'var(--s-ink-2, #556)' },
  sedang_dijana: { bg: 'var(--s-brand-7, rgba(106,90,249,.1))', fg: 'var(--s-brand, #6a5af9)' },
  menyimpan: { bg: 'var(--s-brand-7, rgba(106,90,249,.1))', fg: 'var(--s-brand, #6a5af9)' },
  perlu_semakan: { bg: 'var(--s-warn-7, rgba(239,159,39,.12))', fg: 'var(--s-warn, #b26a00)' },
};
const AKTIF = ['dalam_barisan', 'sedang_dijana', 'menyimpan', 'perlu_semakan'];
const setNo = (sk) => (String(sk || '').match(/\d+/) || ['?'])[0];

export default function HostedStatusKad() {
  const t = useT();
  const [jobs, setJobs] = useState([]);
  const [sibuk, setSibuk] = useState('');

  const muat = useCallback(async () => {
    try { const r = await bacaStatusHostedBeta(); setJobs((r.jobs || []).filter((j) => AKTIF.includes(j.statusPelanggan))); }
    catch { /* senyap — panel hilang kalau backend tiada */ }
  }, []);

  useEffect(() => {
    let stop = false;
    const tick = () => { if (!stop) muat(); };
    tick();
    const tmr = setInterval(tick, 6000);
    return () => { stop = true; clearInterval(tmr); };
  }, [muat]);

  const buatBatal = async (jobId) => {
    if (!window.confirm(t('hosted.batalTanya'))) return;
    setSibuk(jobId);
    try { await batalFlowJob(jobId); await muat(); }
    catch { /* senyap */ } finally { setSibuk(''); }
  };

  if (jobs.length === 0) return null;

  return (
    <div className="s-sect" style={{ padding: '0 0 16px', borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
      <span className="s-lbl" style={{ marginBottom: 8, display: 'block' }}>{t('hosted.jobsAktif')}</span>
      <div style={{ display: 'grid', gap: 6 }}>
        {jobs.map((j) => {
          const tone = TONE[j.statusPelanggan] || TONE.dalam_barisan;
          return (
            <div key={j.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', borderRadius: 8, border: '1px solid var(--s-line)' }}>
              <span style={{ flex: 1, minWidth: 0, fontSize: 12.5, color: 'var(--s-ink, #223)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {j.productName || j.productId}<span style={{ color: 'var(--s-ink-3, #889)' }}> · set {setNo(j.setKey)}</span>
              </span>
              <span style={{ fontSize: 11.5, fontWeight: 600, padding: '2px 9px', borderRadius: 999, background: tone.bg, color: tone.fg, flex: 'none' }}>
                {t('hosted.status.' + j.statusPelanggan)}
              </span>
              {j.statusPelanggan === 'dalam_barisan' && (
                <button type="button" disabled={sibuk === j.id} onClick={() => buatBatal(j.id)}
                  style={{ fontSize: 11.5, padding: '3px 9px', borderRadius: 6, border: '1px solid var(--s-line-strong, #ccc)', background: 'transparent', color: 'var(--s-ink-2, #556)', cursor: 'pointer', flex: 'none' }}>
                  {t('hosted.batal')}
                </button>
              )}
            </div>
          );
        })}
      </div>
      {jobs.some((j) => j.statusPelanggan === 'perlu_semakan') && (
        <p className="s-hint" style={{ margin: '8px 0 0' }}>{t('hosted.perluSemakanNota')}</p>
      )}
    </div>
  );
}
